module.exports = __webpack_public_path__ + "img/wenli-1.8533c214.png";